<div class="container-body">
  <h1 class="title">
    {{ title }}
  </h1>

  <div #dataContainer class="info-container"></div>
</div>
